import React from "react";
import Lottie from "react-lottie";
import animationData from "./success-check.json";

function SuccessCheck({ size }) {
    const options = {
        loop: false,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        },
    };
    return <Lottie options={options} height={size} width={size} />;
}

SuccessCheck.propTypes = {};

SuccessCheck.defaultProps = {
    size: "120px",
};

export default SuccessCheck;
